import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { InspecaoPallet, ResultadoInspecao } from '../../types/qualidade';
import { inspecoesService, lotesMadeiraService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const resultadoOptions: { label: string; value: ResultadoInspecao }[] = [
  { label: 'Aprovado', value: 'APROVADO' },
  { label: 'Rejeitado', value: 'REJEITADO' },
  { label: 'Pendente', value: 'PENDENTE' },
];

const fields: ResourceField<InspecaoPallet>[] = [
  {
    name: 'lote',
    label: 'Lote',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      lotesMadeiraService.list,
      (item: any) => item.lote_info ?? `Lote ${item.id}`,
    ),
    required: true,
  },
  {
    name: 'resultado',
    label: 'Resultado',
    type: 'select',
    options: resultadoOptions,
    required: true,
  },
  { name: 'responsavel', label: 'Responsável' },
  { name: 'observacoes', label: 'Observações', type: 'textarea' },
];

export const InspecoesFormPage: React.FC = () => (
  <ResourceFormPage
    title="Nova inspeção"
    description="Registre uma inspeção de qualidade."
    fields={fields}
    service={inspecoesService}
    redirectPath="/admin/qualidade/inspecoes"
    cancelPath="/admin/qualidade/inspecoes"
  />
);
